export const SET_IS_DRAGGING = 'SET_IS_DRAGGING';
export const SET_CURRENTLY_DRAGGED_PROJECT_ID = 'SET_CURRENTLY_DRAGGED_PROJECT_ID';

export const setIsDragging = (isDragging) => ({
    type: SET_IS_DRAGGING,
    payload: isDragging,
});

export const setCurrentlyDraggedProjectId = (projectId) => ({
    type: SET_CURRENTLY_DRAGGED_PROJECT_ID,
    payload: projectId,
});
